import {MaterialEntry} from '../material/MaterialEntry';
import {TriggerData} from '../trigger/TriggerData.model';
import {DocumentGroupModel} from '../document/document-group.model';

export class JobTemplateUpdateModel {

  id: string;
  name: string;
  description: string;
  flatRate: string;
  producerNumber: string;
  jobTypeId: string;
  moduleId: string;
  jobType: string;
  price: number;
  groupId: string;
  plannedWorkingTime: number;
  triggerData: TriggerData[];
  isActive: boolean;
  documents: DocumentGroupModel[];
  materials: MaterialEntry[];
  assigneeUserId: string;
  assigneeGroupId: string;
  serviceProviderId: string;
  priorityOrder: number; //Frontend implementation
  plannedExecutionAmount: number;
  jobTemplateConditionType: string;
  plannedStandStillTime: number;
  standstill: boolean;
  isPinned: boolean;
  isIdentical: boolean;
  jobBeginStatus: number;
  plannedImplDuration: number;

  inHouseExecution: boolean;
  externExecutionServiceProviderId: string;
}

